

import { Box, Button, Paper, Typography, Breadcrumbs, Grid ,Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableHead, 
    TableRow, 
    
   

    Chip, Modal, Dialog, DialogTitle, DialogContent, DialogActions,
    Avatar, List, ListItem, ListItemAvatar, ListItemText, Divider,FormControlLabel,
    Checkbox, TextField, InputAdornment} from "@mui/material"

import { useDispatch } from "react-redux"
import { updateActiveSideBAr } from "../redux/active_bar"
import AdminSidebar from "../components/adminSideBar"
import Header from "../components/header"
import Header1 from "../components/header1"
import Products from "../components/product"
import OrderComponent from "../components/Orders"
import { useParams } from "react-router-dom"
// import Order_details from "../components/order_details"
// import Header1 from "../components/header1"
import AdminOrderDetails from "../components/adminOrderDetails"
import { TranslateText } from "../utils/googletranslator"
import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import IndianNumFormat from "../components/numberFormat"
import MessageBar from "./messageBar"
import CustomAxios from "../utils/CustomAxios"
import PoolAndShare from "../components/pools_and_shares"
const PoolAndShareConcepts = () => {

    const { orderId } = useParams()
    const [pools, setPools] = useState([])
    const [poolHistory,setPoolHostory ]=useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [selectedPool, setSelectedPool] = useState(null)
    const [shortlistData, setShortlistData] = useState([])
    const [loadingShortlist, setLoadingShortlist] = useState(false)
    const [selectedUsers, setSelectedUsers] = useState([])
    const [sharingAmount, setSharingAmount] = useState(false)
    const [shareAmount, setShareAmount] = useState('')
    // // console.log(orderId)
    const dispatch = useDispatch()
    useEffect(() => {

        CustomAxios.get("/pools_shares",).then((res) => {
            console.log(res.data)
            setPools(res.data.pools_and_sharings)
            setPoolHostory(res.data.pool_history)

        }
        ).catch(err => console.log(err))

    }, [])

    const handlePoolClick = async (pool) => {
        setSelectedPool(pool)
        setModalOpen(true)
        setLoadingShortlist(true)

        try {
            const response = await CustomAxios.get(`/pool_shortlist/${pool.id}/`)
            setShortlistData(response.data.shortlist)
        } catch (error) {
            console.error('Error fetching shortlist:', error)
            setShortlistData([])
        } finally {
            setLoadingShortlist(false)
        }
    }

    const handleCloseModal = () => {
        setModalOpen(false)
        setSelectedPool(null)
        setShortlistData([])
        setSelectedUsers([])
        setShareAmount('')
    }

    const handleUserSelect = (userId) => {
        setSelectedUsers(prev =>
            prev.includes(userId)
                ? prev.filter(id => id !== userId)
                : [...prev, userId]
        )
    }

    const handleSelectAll = () => {
        if (selectedUsers.length === shortlistData.length) {
            setSelectedUsers([])
        } else {
            setSelectedUsers(shortlistData.map(user => user.user_id))
        }
    }

    const handleSharePoolAmount = async () => {
        if (selectedUsers.length === 0 || !selectedPool) return

        const amount = parseFloat(shareAmount)
        if (!amount || amount <= 0) {
            alert('Please enter a valid share amount.')
            return
        }

        if (amount > selectedPool.accumulated) {
            alert(`Share amount cannot exceed the pool's accumulated amount of $${selectedPool.accumulated}.`)
            return
        }

        setSharingAmount(true)
        try {
            const response = await CustomAxios.post('/share_pool_amount/', {
                pool_id: selectedPool.id,
                selected_user_ids: selectedUsers,
                share_amount: amount
            })

            if (response.data.success) {
                // Show success message
                alert(`Successfully shared $${amount} among ${selectedUsers.length} users!`)
                // Reset selections and close modal
                setSelectedUsers([])
                setShareAmount('')
                setModalOpen(false)
            } else {
                alert(response.data.message || 'Failed to share pool amount. Please try again.')
            }
        } catch (error) {
            console.error('Error sharing pool amount:', error)
            alert('An error occurred while sharing the pool amount.')
        } finally {
            setSharingAmount(false)
        }
    }
    // // console.log("its is orders page")

    return <>

        <Box sx={{ bgcolor: { sm: "grey.100", xs: "#fff" }, minHeight: "calc(100vh)" }}>
            <Header1 />
            <Box sx={{ display: "flex", paddingTop: "144px", gap: "24px", mx: "24px", position: "relative" }}>
                <AdminSidebar />
                <Box className="background" sx={{ width: { xs: "calc(100% )", sm: "100%" }, p: { xs: "0px", sm: "20px" }, bgcolor: "#fff" }}>
                    <MessageBar />
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                            <TranslateText sx={{ fontSize: "18px", lineHeight: "28px", fontWeight: "500", color: "#6F7883" }}>Pools and Sharings </TranslateText>


                        </Box>
                        <Grid container columns={12} gap={1} sx={{ justifyContent: "center" }}>

                            {pools?.map(item => <Grid item xs={12} sm={5.5} lg={3.5} sx={{
                                alignSelf: "stretch", alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "space-between", p: { xs: "12px 6px", sm: "12px 16px", lg: "16px 32px" }, border: '5px solid',
                                borderImageSlice: 1,
                                borderImageSource: 'linear-gradient(45deg, #00C2FF 10%, #00E3AF 90%)',
                                padding: '20px',
                                cursor: 'pointer',
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: 'scale(1.02)',
                                }
                            }}
                            onClick={() => handlePoolClick(item)}
                            key={item.id || item.name}
                            >
                                <Typography sx={{ fontSize: "24px", fontWeight: "700", }}>{IndianNumFormat(item.accumulated, true)}</Typography>
                                <Typography sx={{ fontSize: "20", fontWeight: "500" }}>{item.name}</Typography>

                            </Grid>

                            )}

                        </Grid>
                        <PoolAndShare/>
                        {/* <Paper sx={{ width: '100%', overflow: 'hidden', padding: 2 }}> */}
                            <Typography variant="h6" gutterBottom component="div" sx={{ fontWeight: 'bold' }}>
                                Pool Sharing History
                            </Typography>
                            <TableContainer>
                                <Table sx={{ minWidth: 650 }} aria-label="history table">
                                    <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                        <TableRow>
                                            <TableCell>ID</TableCell>
                                            <TableCell>Order ID</TableCell>
                                            <TableCell>Package</TableCell>
                                            <TableCell>From (User name)</TableCell>
                                            <TableCell align="left">Amount</TableCell>
                                            <TableCell>Country</TableCell>
                                            <TableCell align="left">Type</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {poolHistory.map((row) => (
                                            <TableRow key={row.id} hover>
                                                <TableCell>{row.id}</TableCell>
                                                <TableCell>{row.order_id}</TableCell>
                                                <TableCell> {row.package_name}</TableCell>
                                                <TableCell>{row.user_name}</TableCell>
                                                <TableCell align="left" sx={{ fontWeight: 'bold', color: 'green' }}>
                                                    ${row.commission_received}
                                                </TableCell>
                                                <TableCell>{row.country}</TableCell>
                                                <TableCell align="left">
                                                    <Chip
                                                        label={row.type || 'N/A'}
                                                        color={row.type === 'sharing' ? 'success' : row.type === 'accumulated' ? 'primary' : 'default'}
                                                        size="small"
                                                        variant="outlined"
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        {/* </Paper> */}

                    </Box>


                </Box>
            </Box>




        </Box>

        {/* Pool User Shortlist Modal */}
        <Dialog
            open={modalOpen}
            onClose={handleCloseModal}
            maxWidth="md"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '16px',
                }
            }}
        >
            <DialogTitle sx={{
                background: 'linear-gradient(45deg, #00C2FF 10%, #00E3AF 90%)',
                color: 'white',
                textAlign: 'center',
                fontWeight: 'bold'
            }}>
                {selectedPool ? `${selectedPool.name} - Top Performers` : 'Pool Top Performers'}
                <Typography variant="subtitle2" sx={{ mt: 1, opacity: 0.9 }}>
                    {new Date().toLocaleString('default', { month: 'long', year: 'numeric' })} - Monthly Purchases, Accumulated Impact
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                {loadingShortlist ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <Typography>Loading shortlist...</Typography>
                    </Box>
                ) : shortlistData.length > 0 ? (
                    <Box>
                        <Box sx={{ mb: 2 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectedUsers.length === shortlistData.length && shortlistData.length > 0}
                                        indeterminate={selectedUsers.length > 0 && selectedUsers.length < shortlistData.length}
                                        onChange={handleSelectAll}
                                    />
                                }
                                label={`Select All (${selectedUsers.length}/${shortlistData.length} selected)`}
                            />
                        </Box>
                        <Box sx={{ mb: 3 }}>
                            <TextField
                                label="Share Amount"
                                type="number"
                                value={shareAmount}
                                onChange={(e) => setShareAmount(e.target.value)}
                                fullWidth
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                }}
                                helperText={`Available: $${selectedPool?.accumulated || 0} | Will be shared equally among ${selectedUsers.length} selected users`}
                                variant="outlined"
                            />
                        </Box>
                        <List>
                        {shortlistData.map((user, index) => (
                            <div key={user.user_id}>
                                <ListItem sx={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    mb: 1,
                                    backgroundColor: index < 3 ? '#f8f9fa' : 'transparent'
                                }}>
                                    <Checkbox
                                        checked={selectedUsers.includes(user.user_id)}
                                        onChange={() => handleUserSelect(user.user_id)}
                                        sx={{ mr: 1 }}
                                    />
                                    <ListItemAvatar>
                                        <Avatar sx={{
                                            bgcolor: index === 0 ? '#FFD700' : index === 1 ? '#C0C0C0' : index === 2 ? '#CD7F32' : '#00C2FF',
                                            color: 'white',
                                            fontWeight: 'bold'
                                        }}>
                                            {user.rank}
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                {user.first_name} {user.last_name}
                                            </Typography>
                                        }
                                        secondary={
                                            <Box>
                                                <Typography variant="body2" color="text.secondary">
                                                    Mobile: {user.mobileno || 'N/A'}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Referral Code: {user.referral_code || 'N/A'}
                                                </Typography>
                                                <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                                                    <Chip
                                                        label={`Total Spending: $${user.total_commission}`}
                                                        color="primary"
                                                        size="small"
                                                    />
                                                    <Chip
                                                        label={`Monthly Team Amount: $${user.team_purchase_count}`}
                                                        color="secondary"
                                                        size="small"
                                                    />
                                                    {/* <Chip
                                                        label={`Accumulated Team Amount: $${user.team_total_amount}`}
                                                        color="success"
                                                        size="small"
                                                    /> */}
                                                    <Chip
                                                        label={`Team Members: ${user.team_member_count}`}
                                                        color="warning"
                                                        size="small"
                                                    />
                                                </Box>
                                            </Box>
                                        }
                                    />
                                </ListItem>
                                {index < shortlistData.length - 1 && <Divider />}
                            </div>
                        ))}
                        </List>
                    </Box>
                ) : (
                    <Box sx={{ textAlign: 'center', p: 4 }}>
                        <Typography variant="h6" color="text.secondary">
                            No performers found for this pool
                        </Typography>
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 3, justifyContent: 'space-between' }}>
                <Box>
                    {selectedUsers.length > 0 && (
                        <Typography variant="body2" color="primary" sx={{ fontWeight: 'bold' }}>
                            {selectedUsers.length} user{selectedUsers.length > 1 ? 's' : ''} selected
                        </Typography>
                    )}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {selectedUsers.length > 0 && (
                        <>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                            >
                                Export Selected
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                size="small"
                                onClick={handleSharePoolAmount}
                                disabled={sharingAmount}
                            >
                                {sharingAmount ? 'Sharing...' : 'Share Pool Amount'}
                            </Button>
                        </>
                    )}
                    <Button
                        onClick={handleCloseModal}
                        variant="contained"
                        sx={{
                            background: 'linear-gradient(45deg, #00C2FF 10%, #00E3AF 90%)',
                            '&:hover': {
                                background: 'linear-gradient(45deg, #00E3AF 10%, #00C2FF 90%)',
                            }
                        }}
                    >
                        Close
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>

    </>
}



export default PoolAndShareConcepts